import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../_actions';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        const { user } = this.props;

        if (props.match.params.reset_token) {
            let reset_token = props.match.params.reset_token
            if (reset_token) {
                this.props.dispatch(userActions.loginWToken(reset_token));
            }
        }
    }
    
    render() {
        const { loggingIn } = this.props;
        return (
          <div className="col-md-6 col-md-offset-3">
              <h2>Validating Reset Password Token...</h2>
          </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggingIn } = state.authentication;
    const { user } = state;
    return {
        loggingIn,
        user
    };
}

const connectedResetPassword = connect(mapStateToProps)(ResetPassword);
export { connectedResetPassword as ResetPassword };


// WEBPACK FOOTER //
// ./src/ResetPassword/ResetPassword.jsx